import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Breadcrumbs from "../Users/Breadcrumbs";
import { useLocation, useParams } from "react-router-dom";
import { BettingProfitLossTab } from "./BettingProfitLossTab";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import moment from "moment";
import { isEmpty } from "lodash";

const BattingProfitLoss = () => {
  const params = useParams();
  const location = useLocation();
  const [commision, setComission] = useState(0);
  const [key, setKey] = useState("Exchange");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [total2, setTotal2] = useState(0);
  const { setAccountError } = useContext(AuthContext);
  const [total, setTotal] = useState(0);
  const [data2, setData2] = useState({});
  const [innertab, setInnertab] = useState("all");
  const [filter, setFilter] = useState({
    toPeriod: currentDate,
    fromPeriod: previousDate,
    filterByDay: "",
    userType: params.type,
    id: params.id,
    page: 1,
    limit: 100,
  });
  const [data, setData] = useState([]);
  const getData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }

    let obj = {
      ...filter,
      betType:
        key == "Exchange"
          ? "betfair"
          : key == "FancyBet"
          ? "fancy"
          : key == "Sportsbook"
          ? "sportBook"
          : key == "BookMaker"
          ? "bookmaker"
          : key == "Tie"
          ? "tie"
          : key == "Toss"
          ? "toss"
          : key == "parlay"
          ? "parlay"
          : "casino",
    };

    let path = apiPath.betProfitLoss;
    // if (key == "FancyBet") {
    //   path = apiPath.eventSessionBets;
    //   obj = { ...obj, isProfitLoss: true };
    // }
    const { status, data: response_users } = await apiGet(path, obj);
    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);
        setData2(response_users?.results);
        if (response_users.results.data?.length == 0) {
          setAccountError(true);
        } else {
          setAccountError(false);
        }
        setInnertab("all");
        if (response_users?.results?.data?.length > 0) {
          let result = handelChange(response_users?.results?.data, key);
          console.log("result", result);

          setTotal(result);
          setTotal2(result);
        }
        // if (response_users?.results?.data?.length == 0) {
        //   setAccountError(true);
        // } else {
        //   setAccountError(false);
        // }
      } else {
        setData("");
        // setAccountError(true);
      }
    }
  };

  const handelChange = (value, newTab) => {
    if (newTab == "casino") {
      console.log("newTab", newTab, value);
      let temp = value.length > 0;

      const casinoTotal = value?.reduce((a, v) => {
        a = parseFloat(a) + parseFloat(v?.transactions?.realCutAmount);

        return a;
      }, 0);
      // console.log("casinoTotal",casinoTotal)
      return casinoTotal;
    } else {
      let temp = value
        ?.filter((res) => {
          return res?.bets_list?.length > 0;
        })
        ?.map((item) => {
          const backTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "back" &&
              v?.teamSelectionWin === v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }

            return a;
          }, 0);
          const backTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "back" &&
              v?.teamSelectionWin !== v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);

          let backSubTotalresult =
            backTotalProfitAmount > backTotalLoseAmount
              ? backTotalProfitAmount - backTotalLoseAmount
              : -(backTotalLoseAmount - backTotalProfitAmount);

          const layTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "lay" &&
              v?.teamSelectionWin !== v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }
            return a;
          }, 0);

          const layTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "lay" &&
              v?.teamSelectionWin === v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);

          let laySubTotalresult =
            layTotalProfitAmount > layTotalLoseAmount
              ? layTotalProfitAmount - layTotalLoseAmount
              : -(layTotalLoseAmount - layTotalProfitAmount);
          let marketSubTotal = backSubTotalresult + laySubTotalresult;
          const yesTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "Yes" && v?.decisionRun >= v?.betRun) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }
            return a;
          }, 0);

          const yesTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "Yes" && v?.decisionRun < v?.betRun) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);
          let yesSubTotalresult =
            yesTotalProfitAmount > yesTotalLoseAmount
              ? yesTotalProfitAmount - yesTotalLoseAmount
              : -(yesTotalLoseAmount - yesTotalProfitAmount);

          const noTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "No" && v?.decisionRun < v?.betRun) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }
            return a;
          }, 0);
          const noTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "No" && v?.decisionRun >= v?.betRun) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);
          let noSubTotalresult =
            noTotalProfitAmount > noTotalLoseAmount
              ? noTotalProfitAmount - noTotalLoseAmount
              : -(noTotalLoseAmount - noTotalProfitAmount);

          let fancyMarketSubTotal = yesSubTotalresult + noSubTotalresult;
          let fancyNetAmount = fancyMarketSubTotal;
          let v = marketSubTotal > 0 ? marketSubTotal / 100 : "";
          let netAmount = 0;
          let betType =
            newTab == "Exchange"
              ? "betfair"
              : newTab == "sportsBook"
              ? "sportBook"
              : newTab;

          if (betType == "toss" || betType == "tie") {
            netAmount = marketSubTotal;
          } else if (betType == "FancyBet") {
            netAmount = fancyNetAmount;
          } else {
            netAmount = marketSubTotal - v;
          }

          return netAmount;
        });
      return temp.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
    }
  };

  const getFancy = async (item) => {
    let path = apiPath.eventFancyBetsDetail;
    let obj = {
      userType: item?.userType,
      id: item?.userId,
      eventId: item?.eventId,
      selectionId: item?.selectionId,
    };
    const { status, data: response_users } = await apiGet(path, obj);
    if (status === 200) {
      if (response_users.success) {
        setData((prev) => {
          return {
            ...prev,
            data: prev?.data?.map((res) => {
              if (res?._id == item?._id) {
                return { ...res, bets_list: response_users?.results };
              } else {
                return res;
              }
            }),
          };
        });
      }
    }
  };

  useEffect(() => {
    setFilter({
      toPeriod: currentDate,
      fromPeriod: previousDate,
      filterByDay: "",
      userType: params.type,
      id: params.id,
      page: 1,
      limit: 100,
    });
    setKey("Exchange");
  }, [location]);
  useEffect(() => {
    if (innertab == "all") {
      if (data?.data?.length > 0) {
        let result = handelChange(data?.data, key);
        setTotal2(result);
        setData2(data);
      }
    } else {
      let filtered = data?.data?.filter((res) => {
        return res?.eventType == innertab;
      });

      if (filtered?.length > 0) {
        let result = handelChange(filtered, key);
        setTotal2(result);
        setData2((prev) => {
          return {
            ...prev,
            data: filtered,
          };
        });
      } else {
        setData2([]);
        setTotal2(0);
      }
    }
  }, [innertab]);
  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };
  useEffect(() => {
    setPageCount(data?.totalPages || []);
  }, [data]);
  useEffect(() => {
    if (filter.filterByDay != "") {
      getData();
    }
  }, [filter.filterByDay]);
  useEffect(() => {
    setViewPage(filter.page ? filter.page - 1 : 0);
  }, [filter]);

  const redirectCasino = async (userId, platform, platformTxId, type) => {
    const { status, data: response_users } = await apiGet(
      apiPath.casinoWalletHistory +
        "?userId=" +
        userId +
        "&platform=" +
        platform +
        "&platformTxId=" +
        platformTxId
    );
    //console.log(response_users, status);
    if (status === 200) {
      if (response_users.status) {
        if (response_users.data?.status === "0000") {
          if (type === 1) {
            javascript: window.open(
              response_users.data?.txnUrl,
              "_blank",
              "height=900,width=1200"
            );
          } else {
            javascript: window.open(
              response_users.data?.url,
              "_blank",
              "height=900,width=1200"
            );
          }
        } else {
          toast.error(response_users.data.desc);
        }
      } else {
        toast.error(response_users.data.desc);
      }
    } else {
      toast.error(response_users.data.desc);
    }
  };
  const [summaryData, setSummaryData] = useState({});
  const accountSummary = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.userProfile + "?user_id=" + params?.id
    );
    if (status === 200) {
      if (response_users.success) {
        setSummaryData(response_users.results);
        setComission(response_users.results.commission);
      }
    }
  };
  useEffect(() => {
    if (params?.id) {
      accountSummary();
    }
  }, [params?.id]);
  return (
    <div className="top-header-inner">
      <section className="py-4 main-inner-outer">
        <Container fluid>
          <Breadcrumbs user_id={params?.id} />
          <div className="accout_cols_outer">
            <div className="left_side">
              <Sidebar />
            </div>
            <div className="right_side">
              <div className="inner-wrapper">
                <h2 className="common-heading">
                  {location.pathname.split("/")[1] == "betting-history"
                    ? "Betting History"
                    : "Betting Profit Loss"}
                </h2>
                <ul class="acc-info">
                  <li class="user">{summaryData?.username}</li>
                </ul>
                <div className="common-tab">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => {
                      setKey(k);
                      setFilter({
                        betType: "",
                        status: "completed",
                        fromPeriod: previousDate,
                        toPeriod: currentDate,
                        filterByDay: "",
                        page: 1,
                        limit: 100,
                        userType: params.type,
                        id: params.id,
                      });
                      setData({});
                      setTotal(0);
                      setTotal2(0);
                      setInnertab("all");
                      setData2({});
                    }}
                  >
                    <Tab eventKey="Exchange" title="Exchange">
                      {key === "Exchange" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"betfair"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data2}
                          getData={getData}
                          summaryData={summaryData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          dataOld={data}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="FancyBet" title="FancyBet">
                      {key === "FancyBet" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"fancy"}
                          setFilter={setFilter}
                          getFancy={getFancy}
                          filter={filter}
                          data={data2}
                          summaryData={summaryData}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          dataOld={data}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="casino" title="Casino">
                      {key === "casino" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"casino"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data2}
                          summaryData={summaryData}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          redirectCasino={redirectCasino}
                          comission={commision}
                          total={total}
                          dataOld={data}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Sportsbook" title="Sportsbook">
                      {key === "Sportsbook" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"sportBook"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data2}
                          summaryData={summaryData}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          dataOld={data}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="BookMaker" title="BookMaker">
                      {key === "BookMaker" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          dataOld={data}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          summaryData={summaryData}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="BPoker" title="BPoker">
                      {key === "BPoker" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          dataOld={data}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          summaryData={summaryData}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="SABA" title="SABA">
                      {key === "SABA" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          dataOld={data}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          summaryData={summaryData}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="MiniGame" title="MiniGame">
                      {key === "MiniGame" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          dataOld={data}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          summaryData={summaryData}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Royal" title="Royal">
                      {key === "Royal" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          dataOld={data}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          summaryData={summaryData}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          comission={commision}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    {/* <Tab eventKey="Toss" title="Toss">
                      {key === "Toss" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"toss"}
                          setFilter={setFilter}
                          filter={filter}
                          summaryData={summaryData}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          redirectCasino={redirectCasino}
                          comission={commision}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Tie" title="Tie">
                      {key === "Tie" && (
                        <BettingProfitLossTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"tie"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          summaryData={summaryData}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          redirectCasino={redirectCasino}
                          comission={commision}
                        />
                      )}
                    </Tab> */}
                    {/* <Tab eventKey="parlay" title="Parlay">
                      {key === "parlay" && (
                        <BettingProfitLossTab
                          betType={"parlay"}
                          title={key}
                          summaryData={summaryData}
                          filter={filter}
                          setFilter={setFilter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab> */}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default BattingProfitLoss;
